// extracted by mini-css-extract-plugin
module.exports = {"postfix":"_99551c8aa8--postfix--Jwk65"};